import { youtubeUrl, getYoutubeVideoCover, getVideoCover } from './helpers';

interface VideoCoverImage {
	image: HTMLElement;
	defaultImage: HTMLElement;
}

export const getVideoCoverImage = (element: Element, htmlDocument: Document): VideoCoverImage => {
	const isVideo = element.tagName === 'VIDEO';
	const elementWithSrc = isVideo
		? element.querySelector('source')
		: element;
	const { src } = elementWithSrc as HTMLMediaElement;

	const image = htmlDocument.createElement('img');
	image.src = isVideo ? getVideoCover(src) : getYoutubeVideoCover(src);
	image.alt = '';
	const imageStyle = 'position:absolute;top:0;bottom:0;left:0;right:0;max-width:100%;max-height:100%;width:auto;height:auto;margin:auto;';
	image.setAttribute('style', imageStyle);
	image.setAttribute('onerror', 'this.onerror=null;this.setAttribute("hidden", "true")');

	const defaultImage = htmlDocument.createElement('svg');
	const defaultImageStyle = 'position:absolute;top:0;bottom:0;left:0;right:0;z-index:-1;max-width:100%;max-height:100%;width:50%;height:50%;margin:auto;fill:#a4a4a4';
	defaultImage.setAttribute('style', defaultImageStyle);
	const useElement = htmlDocument.createElement('use');
	useElement.setAttribute('xlink:href', '#svgicon-iconset_uprez_play-button');
	defaultImage.appendChild(useElement);

	return {
		image,
		defaultImage,
	};
};

const replaceVideoWithCoverImage = (element: Element, htmlDocument: Document): void => {
	const { image, defaultImage } = getVideoCoverImage(element, htmlDocument);
	const { parentNode } = element;

	if (parentNode) {
		parentNode.removeChild(element);
		parentNode.appendChild(image);
		parentNode.appendChild(defaultImage);
	}
};

export const replaceVideosWithCoverImages = (htmlDocument: Document): Document => {
	const videoElements = [
		...htmlDocument.querySelectorAll(`video, iframe[src*="${youtubeUrl}"]`)
	];

	videoElements.forEach(element => replaceVideoWithCoverImage(element, htmlDocument));

	return htmlDocument;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/utils/videos.ts